// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23pYT","colBig":"styles_colBig__3cB27","colSmall":"styles_colSmall__3tZg5","shopifyNameWrapper":"styles_shopifyNameWrapper__1PkTt"};